<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section v-if="isLoad" class="geo-section geo-section--location vip-services-section">
            <div class="page-title page-title_align-center page-title_vip">
              <h2>Setting & Data | VIP Service</h2>

              <div class="page-title__side">
                <span class="label-year">Year:</span>
                <div
                  :class="['select-wrapper', 'select-wrapper_year-sm', { 'is-active' : selects.year }]"
                  @click="openSelect('year')"
                >
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{ year || '' }}</span>
                    <span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                      </svg>
                    </span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                        v-for="(item, index) in data.years" :key="index"
                        :class="['select-option', { 'is-selected' : item === year }]"
                        @click="year = item"
                      >
                        <span class="select-option__name">{{ item }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="copyPopup = true" type="button" class="btn btn--green btn--sm-squared">
                  <svg width="1em" height="1em" class="icon icon-copy ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                  </svg>
                </button>
              </div>
            </div>
            <div class="vip-services">
              <div v-for="(service, index) in services" :key="index" class="hotels-seasons-item">
                <div class="form-control-group">
                  <span v-if="index === 0" class="form-control-label">Airport</span>
                  <div
                    :class="['select-wrapper', { 'is-active' : service.active, 'is-error': service.airportError }]"
                    @click="services = services.map((cur, i) => ({ ...cur, active : i === index ? !cur.active : false }))"
                  >
                    <div class="select-trigger">
                      <span class="select-trigger__name">
                        {{ service.airstripId ? data.airstrips.find(airport => airport.id === service.airstripId).names.EN : 'Select' }}
                      </span>
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                            v-for="(item, i) in data.airstrips" :key="i"
                            :class="['select-option', { 'is-selected' : item.id === service.airstripId }]"
                            @click="service.airstripId = item.id; service.airportError = false;isEdit = true"
                        >
                          <span class="select-option__name">{{ item.names.EN || '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-control-group">
                  <span v-if="index === 0" class="form-control-label">Price per person</span>
                  <div class="form-control-wrap form-control-wrap_with-label">
                    <input
                        v-model.number="service.price"
                        @input="isEdit = true"
                        @focus="$event.target.parentElement.classList.remove('is-error')"
                        type="number" placeholder="0"
                        class="form-control form-control--right">
                    <span class="label-inp">USD</span>
                  </div>
                </div>
                <button
                  @click="$emit('deleteModalHandler', {
                    entity: 'Service',
                    name: 'this',
                    handler: removeService,
                    id: index
                  })"
                  type="button"
                  class="btn btn--remove"
                >
                  <svg width="1em" height="1em" class="icon icon-close ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                  </svg>
                </button>
              </div>
              <div class="edit-seasons__btns">
                <button @click="addServiceHandler" type="button" class="btn btn--rounded2 btn--add btn--green">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>Add</span></button>
              </div>
              <button @click="postServices" type="button" class="btn btn--green"><span>Save</span></button>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="copyPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-md">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
              </div>
              <span>Copy from another year</span>
            </div>
            <div class="edit-popup__close" @click="copyPopup = false">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__form-2">
              <div class="form-control-group"><span class="form-control-label">Choose year</span>
                <div
                  :class="['select-wrapper', { 'is-active' : selects.copyYear }]"
                  @click="selects.copyYear = !selects.copyYear"
                >
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{ copyYear }}</span>
                    <span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                      </svg>
                    </span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                        v-for="(y, index) in data.years.filter(y => y !== year)"
                        :key="index"
                        :class="['select-option', { 'is-selected' : copyYear === y }]"
                        @click="copyYear = y"
                      >
                        <span class="select-option__name">{{ y }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn--green edit-popup__submit-2"
                @click="copyYearOldHandler(); copyPopup = false; isEdit = true;"
              >
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
                <span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  copyAirportVipServices,
  getAirportVipServices, getAirstripsAll, postAirportVipServices
} from '@/utilites/api'

export default {
  name: 'Vip',
  data() {
    return {
      isLoad: false,
      selects: {
        year: false,
        copyYear: false
      },
      year: new Date().getFullYear(),
      copyYear: '',
      data: {
        years: [],
        copyYears: [],
        airstrips: [],
      },
      services: [
        {
          id: null,
          year: null,
          airstripId: null,
          priceForType: 'PER_PERSON',
          price: null
        }
      ],
      copyPopup: false,
      isEdit: false,
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Airport VIP Services'
  },
  created() {
    this.data.years = Array(10).fill(true).map((_, index) => new Date().getFullYear() + index)
    this.getAirstrips()
  },
  mounted() {
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          year: false,
          copyYear: false
        }
        this.services = this.services.map(cur => ({ ...cur, active : false }))
      }
    })
  },
  beforeRouteLeave(to, from, next){
    if(this.isEdit){
      this.$emit('notLeaveHandler')
    }
    next()
  },
  watch: {
    year() {
      this.getAirstrips()
    }
  },
  methods: {
    getAirstrips() {
      Promise.all([getAirportVipServices(this.year), getAirstripsAll()])
        .then(res => {
          this.services = res[0].data.map(item => ({ ...item, active: false }))
          this.data.airstrips = res[1].map(item => ({
            ...item.airstrip
          })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)

          this.isLoad = true
        })
    },
    checkErrors(){
      let error = false
      document.querySelectorAll('input[type="number"]').forEach(elem => {
        if(+elem.value === 0){
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      this.services = this.services.map(item => !item.airstripId ? ({...item, airportError: true }) : ({...item, airportError : false}))
      return error || this.services.find(item => item.airportError)
    },
    copyYearOldHandler() {
      this.isLoad = false

      copyAirportVipServices(this.copyYear, this.year)
        .then(res => {
          this.services = res.data.map(item => ({ ...item, active: false }))
          this.isLoad = true
        })
    },
    removeService(index) {
      if (index > -1) {
        this.services.splice(index, 1)
        this.isEdit = true
      }
    },
    postServices() {
      if (!this.checkErrors()) {
        const postData = this.services.map(item => {
          let obj = {
            year : +item.year,
            airstripId : item.airstripId,
            priceForType : item.priceForType,
            price : +item.price,
          }
          if (item.id) {
            obj.id = item.id
          }
          return obj
        })
        postAirportVipServices(this.year, postData)
            .then(res => {
              this.$emit('confirmed')
              this.isEdit = false
            })
      }
    },
    addServiceHandler() {
      this.services = this.services.concat({
        year: +this.year,
        airstripId: null,
        priceForType: 'PER_PERSON',
        price: '',
        active: false
      })
    },
    openSelect(name) {
      this.selects = {
        year: false,
        copyYear: false,
        [name]: !this.selects[name]
      }
    },
  }
}
</script>
